import { render, staticRenderFns } from "./campaignsList.vue?vue&type=template&id=05e9a494&"
import script from "./campaignsList.vue?vue&type=script&lang=js&"
export * from "./campaignsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports